const normalizeDate = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate())

const parseDate = (dateString: string) => {
  const date = new Date(dateString)
  return isNaN(date.getTime()) ? null : date
}

export const isToday = (dateString: string) => {
  const date = parseDate(dateString)
  if (!date) return false

  const today = new Date()

  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  )
}

export const formatDate = (dateString: string) => {
  const date = parseDate(dateString)
  if (!date) return dateString

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  return `${day}/${month}/${year}`
}

export const calculateDaysSinceLastWeighing = (currentDate: string, nextDate?: string) => {
  const current = parseDate(currentDate)
  if (!current) return 0

  const normalizedCurrent = normalizeDate(current)

  let next: Date

  if (nextDate) {
    const parsedNext = parseDate(nextDate)
    if (!parsedNext) return 0
    next = normalizeDate(parsedNext)
  } else {
    next = normalizeDate(new Date())
  }

  const diffTime = next.getTime() - normalizedCurrent.getTime()
  return Math.round(diffTime / (1000 * 60 * 60 * 24))
}

export const formatTime = (dateString: string) => {
  const date = parseDate(dateString)
  if (!date) return ''

  return date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  })
}
